export default __webpack_public_path__ + "static/media/hamtaland - 512-min.d79a661f.png";